import { Search } from "react-feather";
import {
  Button,
  CardBody,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import PaginationComponent from "Component/Learning/Common/Pagination";
import {
  setFilters as setFiltersTicket
} from '../../../../Features/Learning/Ticket/ticketSlice';
import {
  setFilters as setFiltersTryout
} from "Features/Learning/Tryout/tryoutSlice";
import { fetchTryout } from "Features/Learning/Tryout/Utils/TryoutUtils";
import {
  handleBackPagination,
  handleClickPagination,
  handleNextPagination
} from "Component/Learning/Tryout/TryoutUtils";

const ModalAddTryout = ({
  handleOpenTryout,
  openTryout,
  selectedValue,
  setSelectedValue
}) => {
  const dispatch = useDispatch();

  const [dataTryout, setDataTryout] = useState([]);
  const [search, setSearch] = useState('');
  const [refetch, setRefetch] = useState(false);

  const TicketFilters = useSelector(state => state.Ticket.filters);
  const TryoutFilters = useSelector(state => state.Tryout.filters);
  const isLoading = useSelector(state => state.Tryout.isLoading);
  const pagination = useSelector(state => state.Tryout.data.pagination);
  const data = useSelector(state => state.Tryout.detail);

  const fetchData = () => {
    dispatch(fetchTryout({ ...TryoutFilters }))
      .then((response) => {
        setDataTryout(response?.payload?.data || []);
      })
      .catch((error) => {
        console.error('Error fetching tryout:', error);
      });
  };

  useEffect(() => {
    fetchData();
  }, [refetch, openTryout]);

  useEffect(() => {
    const currentTryoutId = TicketFilters["filter[tryout_id]"];

    if (currentTryoutId !== "") {
      dispatch(fetchTryout({
        ...TryoutFilters,
        "filter[id]": currentTryoutId,
        page: 1
      })).then((response) => {
        setSelectedValue(response?.payload?.data[0] || {});
      });
    } else {
      setSelectedValue({});
    }
  }, [TicketFilters]);

  const updateSearchParams = useCallback(() => {
    dispatch(setFiltersTryout({
      ...TryoutFilters,
      "filter[title]": search,
      page: 1
    }));
  }, [search]);

  useEffect(() => {
    const delay = setTimeout(updateSearchParams, 500);
    return () => clearTimeout(delay);
  }, [search]);

  const handleClickSearch = () => {
    setRefetch(prev => !prev);
  };

  const handleRadioChange = (item) => {
    setSelectedValue(item);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(setFiltersTicket({
      ...TicketFilters,
      "filter[tryout_id]": selectedValue?.id || ""
    }));
    handleOpenTryout(false);
  };

  const handleCancel = () => {
    handleOpenTryout(false);
    const currentTryoutId = TicketFilters["filter[tryout_id]"];

    if (selectedValue?.id !== currentTryoutId && currentTryoutId !== "") {
      dispatch(fetchTryout({
        ...TryoutFilters,
        "filter[id]": currentTryoutId,
        page: 1
      })).then((response) => {
        console.log(response)
        setSelectedValue(response?.payload?.data[0] || {});
      });
      console.log(selectedValue?.id, currentTryoutId)
    }
  };

  console.log(selectedValue, TryoutFilters, TicketFilters)

  return (
    <Modal isOpen={openTryout} size="lg">
      <ModalHeader onClick={handleOpenTryout}>
        Tambahkan Tryout ke Filter
      </ModalHeader>
      <ModalBody>
        {Object.keys(selectedValue).length > 0 && (
          <ul>
            <li>
              {selectedValue?.id} - {selectedValue?.title}
            </li>
          </ul>
        )}
        <div className="faq-form mt-3 d-flex align-items-center">
          <Input
            className="form-control"
            type="text"
            placeholder="Search.."
            value={search}
            onKeyUp={(e) => e.key === "Enter" && handleClickSearch()}
            onChange={(e) => setSearch(e.target.value)}
          />
          <Search className="search-icon ms-2" />
        </div>
        <Table className="table-responsive table-bordered my-3">
          <thead className="table-light">
            <tr>
              <th scope="col">#</th>
              <th scope="col">ID</th>
              <th scope="col">Nama Tryout</th>
              <th scope="col" className="text-center">Pilih</th>
            </tr>
          </thead>
          <tbody>
            {dataTryout?.map((item, index) => (
              <tr key={`item-${index}`}>
                <th>{pagination?.from + index}</th>
                <th>{item.id}</th>
                <td>{item.title}</td>
                <td className="text-center">
                  <Input
                    className="radio_animated"
                    name="tryoutRadio"
                    type="radio"
                    checked={selectedValue?.id === item.id}
                    onChange={() => handleRadioChange(item)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <CardBody>
          {!isLoading && pagination && (
            <PaginationComponent
              pagination={pagination}
              handleBackPagination={() =>
                handleBackPagination(pagination, TryoutFilters, dispatch, setFiltersTryout, setRefetch)
              }
              handleClickPagination={(page) =>
                handleClickPagination(page, TryoutFilters, dispatch, setFiltersTryout, setRefetch)
              }
              handleNextPagination={() =>
                handleNextPagination(pagination, TryoutFilters, dispatch, setFiltersTryout, setRefetch)
              }
            />
          )}
        </CardBody>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSubmit}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalAddTryout;
